<template>
  <div class="tableSonTemp">
    <template v-if="data">
      <el-popover
        :title="config.label ? config.label : config.cnName + '查看'"
        trigger="hover"
        width="300"
      >
        <div v-html="data" class="richStyle"></div>
        <template slot="reference">
          <span style="cursor: pointer">
            <i class="el-icon-news elOpStyle"></i>
            {{ config.label ? config.label : config.cnName + "查看" }}
          </span>
        </template>
      </el-popover>
    </template>
    <div v-else>-</div>
  </div>
</template>
<script>
export default {
  props: ["data", "config"],
  data() {
    return {};
  },
  methods: {},
};
</script>
